import useLazySelector, { isCustomer } from "common/redux/useLazySelector";
import { Offering } from "./offering";
import { loadOfferings } from "./offerings.actions";

export default function useOfferings(alwaysRetrieve?: boolean): Offering[] {
    const shouldRetrieve = alwaysRetrieve ? () => true : isCustomer;
    
    return useLazySelector(store => store.offerings, dispatch => loadOfferings()(dispatch), shouldRetrieve, []);
}